import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerAccountHeaderComponent } from 'src/app/components/customerAccounts/customer-account-header/customer-account-header.component';
import { CustomerAccountComponent } from 'src/app/components/customerAccounts/customer-account/customer-account.component';
import { OpenAccountComponent } from 'src/app/components/customerAccounts/open-account/open-account.component';
import { CustomerSearchComponent } from 'src/app/components/customerAccounts/customer-search/customer-search.component';
import { MaterialModule } from '../shared module/material.module';
import { AlightDropDownComponent } from 'src/app/components/common/alight-drop-down/alight-drop-down.component';
import { AlightSmartSearchDropDownComponent } from 'src/app/components/common/alight-smart-search-drop-down/alight-smart-search-drop-down.component';
import { AutoFocusDirective } from 'src/app/directives/auto-focus.directive';
import { CustomerCaseManagementCardComponent } from 'src/app/components/customerAccounts/customer-case-management-card/customer-case-management-card.component';
import { ResizeColumnDirective } from 'src/app/directives/resize-column.directive';
import { AlightTableComponent } from 'src/app/components/common/alight-table/alight-table.component';
import { TreeTableComponent } from 'src/app/components/common/tree-table/tree-table.component';
import { AdditionalAccountModalComponent } from 'src/app/components/customerAccounts/additional-account-modal/additional-account-modal.component';
import { SharedModule } from '../shared module/shared.module';
import { DomainDetailsComponent } from 'src/app/components/customerAccounts/domain-details/domain-details.component';
import { AuthenticationComponent } from 'src/app/components/customerAccounts/authentication/authentication.component';
import { ScrollSpyDirective } from 'src/app/directives/scroll-spy.directive';
import { CustomerSearchUnidentifiedCallComponent } from 'src/app/components/customerAccounts/customer-search-unidentified-call/customer-search-unidentified-call.component';
import { PeekabooModalComponent } from 'src/app/components/customerAccounts/peekaboo-modal/peekaboo-modal.component';
import { InteractionHistoryListViewComponent } from 'src/app/components/customerAccounts/interaction-history-list-view/interaction-history-list-view.component';
import { InteractionHistoryBriefViewComponent } from 'src/app/components/customerAccounts/interaction-history-brief-view/interaction-history-brief-view.component';
import { InteractionHistoryDetailViewComponent } from 'src/app/components/customerAccounts/interaction-history-detail-view/interaction-history-detail-view.component';
import { AbtTheInteractionCardComponent } from 'src/app/components/customerAccounts/abt-the-interaction-card/abt-the-interaction-card.component';
import { ApprovedExceptionComponent } from 'src/app/components/customerAccounts/approved-exception/approved-exception.component';
import { WrapUpComponent } from 'src/app/components/customerAccounts/wrap-up/wrap-up.component';
import { DisplayAlertComponent } from 'src/app/components/customerAccounts/display-alert/display-alert.component';
import { UnknownCallerComponent } from 'src/app/components/customerAccounts/unknown-caller/unknown-caller.component';
import { CreateAlertComponent } from 'src/app/components/customerAccounts/create-alert/create-alert.component';
import { FilterDataComponent } from 'src/app/components/customerAccounts/filter-data/filter-data.component';
import { OnDemandEmailComponent } from 'src/app/components/customerAccounts/on-demand-email/on-demand-email.component';
import { FTUPanelComponent } from 'src/app/components/customerAccounts/ftu-panel/ftu-panel.component';
import { PinResetPanelComponent } from 'src/app/components/customerAccounts/pin-reset-panel/pin-reset-panel.component';
import { OneTimeCodeComponent } from 'src/app/components/customerAccounts/one-time-code/one-time-code.component';
import { TbaDomainSelectionComponent } from 'src/app/components/customerAccounts/tba-domain-selection/tba-domain-selection.component';
import { VoluntaryAccountLockComponent } from 'src/app/components/customerAccounts/voluntary-account-lock/voluntary-account-lock.component';
import { ViewExpiredAlertsComponent } from 'src/app/components/customerAccounts/view-expired-alerts/view-expired-alerts.component';
import { OtcPhoneFlowComponent } from 'src/app/components/customerAccounts/otc-phone-flow/otc-phone-flow.component';
import { ViewJsonComponent } from 'src/app/components/customerAccounts/view-json/view-json.component';
import { PinEntryFsbsComponent } from 'src/app/components/customerAccounts/pin-entry-fsbs/pin-entry-fsbs.component';
import { PinReminderComponent } from 'src/app/components/customerAccounts/pin-reminder/pin-reminder.component';


@NgModule({
  declarations: [
    CustomerAccountComponent,
    CustomerAccountHeaderComponent,
    OpenAccountComponent,
    DomainDetailsComponent,
    CustomerSearchComponent,
    AutoFocusDirective,
    CustomerCaseManagementCardComponent,
    AlightDropDownComponent,
    AlightSmartSearchDropDownComponent,
    ResizeColumnDirective,
    ScrollSpyDirective,
    AlightTableComponent,
    AdditionalAccountModalComponent,
    AuthenticationComponent,
    CustomerSearchUnidentifiedCallComponent,
    InteractionHistoryBriefViewComponent,
    PeekabooModalComponent,
    InteractionHistoryListViewComponent,
    InteractionHistoryDetailViewComponent,
    TreeTableComponent,
    AbtTheInteractionCardComponent,
    ApprovedExceptionComponent,
    WrapUpComponent,
    DisplayAlertComponent,
    UnknownCallerComponent,
    CreateAlertComponent,
    FilterDataComponent,
    OnDemandEmailComponent,
    FTUPanelComponent,
    PinResetPanelComponent,
    OneTimeCodeComponent,
    TbaDomainSelectionComponent,
    VoluntaryAccountLockComponent,
    ViewExpiredAlertsComponent,
    OtcPhoneFlowComponent,
    ViewJsonComponent,
    PinEntryFsbsComponent,
    PinReminderComponent
  ],
  imports: [SharedModule],
  providers: [],
  exports: [AlightDropDownComponent,AlightSmartSearchDropDownComponent, AutoFocusDirective, AlightTableComponent,CreateAlertComponent, ViewExpiredAlertsComponent,
    OtcPhoneFlowComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CustomerAccountsModule { }
